import { axios } from '@Shared/plugins/axios';

export const useAxios = () => axios;
